// @ts-ignore
import * as THREE from "three";
import { MathUtils, Vector2 } from "three";
import { groundColor, groundNormal, groundRoughness } from "./assets/materials";
var degToRad = MathUtils.degToRad;
export class Ground {
    constructor(scene) {
        this.createGround(scene);
    }
    createGround(scene) {
        const sides = scene.dimensions;
        const groundMap = new THREE.Texture();
        const groundRoughnessMap = new THREE.Texture();
        const groundNormalMap = new THREE.Texture();
        const xSide = sides.left.length + 60;
        const zSide = sides.close.length + 60;
        const groundTextureRepeat = new Vector2(xSide / 1024 * 2, zSide / 1024 * 2);
        groundMap.repeat = groundTextureRepeat;
        scene.assignTexture(groundMap, groundColor);
        scene.assignTexture(groundRoughnessMap, groundRoughness);
        scene.assignTexture(groundNormalMap, groundNormal);
        let groundMaterial = new THREE.MeshStandardMaterial({
            map: groundMap,
            normalMap: groundNormalMap,
            roughnessMap: groundRoughnessMap,
            polygonOffset: true,
            polygonOffsetFactor: -1.0,
        });
        groundMaterial.needsUpdate = true;
        const mesh = new THREE.Mesh(new THREE.BoxGeometry(xSide, zSide, 20), groundMaterial);
        mesh.rotation.x = -Math.PI / 2;
        mesh.receiveShadow = true;
        if (scene.formData.measuredModel.rotated === true) {
            mesh.rotateZ(degToRad(90));
        }
        mesh.position.copy(sides.centerPos);
        scene.threeScene.add(mesh);
    }
}
